import { combineReducers } from 'redux'

import ui from './uiReducer'
import map from 'modules/map'
import data from 'modules/data'
import user from './userReducer'
import traps from 'modules/trap'
import toast from 'modules/toast'
import groups from 'modules/group'
import people from 'modules/people'
import invites from 'modules/invite'
import popovers from 'modules/popover'
import progress from './progressReducer'
import organisation from 'modules/organisation'

const reducers = combineReducers({
  ui,
  map,
  data,
  user,
  toast,
  traps,
  people,
  groups,
  invites,
  popovers,
  progress,
  organisation,
})

export default reducers



// WEBPACK FOOTER //
// ./src/reducers/index.js